const pick = (object, ...keys) => {
  const newObject = {}
  keys.forEach((key) => {
    if (key in object)
      newObject[key] = object[key]
  })
  return newObject
}

module.exports = pick



// WEBPACK FOOTER //
// ../node_modules/berries/lib/pick.js